<template>
  <div>
    <vue-element-loading :active="appLoading" :is-full-screen="true" />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showsnackbar" color="#63028F" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{msg1}}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showsnackbar = false">
            <v-icon style="color:white;">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap justify-center>
      <v-flex px-2 xs12 sm12 md10 lg12 xl8 text-left>
        <v-layout pt-8 wrap justify-center>
          <v-flex text-center xs12 md12 lg12>
            <span
              style="color:#000000;font-family: poppinsbold;font-size:22px"
            >Register and Start Selling</span>
          </v-flex>
        </v-layout>
        <v-layout wrap justify-center>
          <v-flex text-center xs12 md12 lg12>
            <span
              style="color:#000000;font-family:poppinsregular;letter-spacing: 0.42px;font-size:font-size:14px;"
            >Please ensure that all the information you submit is accurate.</span>
          </v-flex>
        </v-layout>
        <v-layout wrap>
          <v-flex xs12 pt-8>
            <v-text-field
              ref="fullName"
              color="#63028F"
              label="Name of the Company / Shop"
              outlined
              dense
              v-model="seller.organization"
            ></v-text-field>
            <v-text-field
              ref="ownerName"
              color="#63028F"
              label="Name of the Owner"
              outlined
              dense
              v-model="userData.fullname"
            ></v-text-field>

            <span style="font-family:opensansbold">Address Line</span>
            <v-card class="mx-auto" outlined>
              <v-layout wrap pa-3>
                <v-flex xs12 md12 lg12>
                  <v-text-field
                    ref="streetAddress"
                    color="#63028F"
                    label="Address of the Owner"
                    outlined
                    dense
                    v-model="seller.streetAddress"
                  ></v-text-field>
                  <v-layout wrap>
                    <v-flex xs5 md5 lg5>
                      <v-text-field
                        ref="locality"
                        color="#63028F"
                        label="Locality"
                        dense
                        v-model="seller.locality"
                      ></v-text-field>
                    </v-flex>

                    <v-flex offset-md1 xs5 md5 lg5>
                      <v-text-field
                        ref="city"
                        color="#63028F"
                        label="City"
                        dense
                        v-model="seller.city"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs5 md5 lg5>
                      <v-text-field
                        ref="district"
                        color="#63028F"
                        label="District"
                        dense
                        v-model="seller.district"
                      ></v-text-field>
                    </v-flex>

                    <v-flex offset-md1 xs5 md5 lg5>
                      <v-text-field
                        ref="state"
                        color="#63028F"
                        label="State"
                        dense
                        v-model="seller.state"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>

            <v-card class="mx-auto" outlined>
              <v-layout wrap pa-3>
                <v-flex xs12 md12 lg12>
                  <v-layout wrap>
                    <v-flex xs4 md3 lg3>
                      <span style="color:#000000;font-family: poppinssemibold;">Upload ID Proof</span>
                    </v-flex>
                    <v-flex xs1 md1 lg1>
                      <v-img src="./../../assets/images/fileupload.png" contain height="20px"></v-img>
                    </v-flex>
                  </v-layout>
                  <v-layout pb-3 wrap pt-4>
                    <v-flex xs9 md9 lg9>
                      <span style="color:#000000;font-family: poppinsregular;">{{filename}}</span>
                    </v-flex>
                    <v-flex xs2 md2 lg2>
                      <!-- <span>
                        <v-btn style="border-radius:14px;border: 0.5px solid #707070;" px-5 pt-0 text outlined>View</v-btn>
                      </span>-->
                    </v-flex>
                    <v-flex xs2 md1 lg1>
                      <span>
                        <v-img
                          @click="delDocument"
                          width="100%"
                          height="20px"
                          contain
                          src="./../../assets/images/trash.png"
                        ></v-img>
                      </span>
                    </v-flex>
                  </v-layout>
                  <v-divider dotted></v-divider>
                  <v-layout wrap pt-4>
                    <v-flex xs11 md2 lg11>
                      <span style="color:#000000;font-family: poppinsregular;">Add</span>
                    </v-flex>
                    <v-flex xs2 md10 lg1>
                      <span>
                        <v-btn
                          small
                          :ripple="false"
                          id="pro_pic"
                          class="text-capitalize"
                          outlined
                          color="transparent "
                          width="20"
                          @click="$refs.uploadDocuments.click()"
                        >
                          <v-img
                            src="./../../assets/images/addicon.png"
                            aspect-ratio="1"
                            contain
                            height="20px"
                          >
                            <template v-slot:placeholde>
                              <v-row class="fill-height ma-0" align="center" justify="center">
                                <v-progress-circular indeterminate color="#26af82"></v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>
                        </v-btn>
                        <input
                          v-show="false"
                          ref="uploadDocuments"
                          accept="image/*"
                          type="file"
                          @change="uploadDocuments"
                        />
                      </span>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>
            <br />
            <v-card class="mx-auto" outlined>
              <v-layout wrap pa-3>
                <v-flex xs12 md12 lg12>
                  <v-layout wrap>
                    <v-flex xs4 md4 lg4>
                      <span style="color:#000000;font-family: poppinssemibold;">Upload the Photo</span>
                    </v-flex>
                    <v-flex xs1 md1 lg1>
                      <v-img
                        width="100%"
                        height="20px"
                        contain
                        src="./../../assets/images/fileupload.png"
                      ></v-img>
                    </v-flex>
                    <v-flex xs2 md3 offset-md3 lg3>
                      <span>
                        <v-img
                          v-if="proPicImg"
                          id="proPicImg"
                          :src="proPicImg"
                          aspect-ratio="1"
                          contain
                          height="100%"
                        >
                          <!-- <template v-slot:placeholder>
                          </template>-->
                        </v-img>
                      </span>
                    </v-flex>
                    <v-flex xs2 md1 lg1>
                      <v-img
                        @click="delProPic"
                        width="100%"
                        height="20px"
                        contain
                        src="./../../assets/images/trash.png"
                      ></v-img>
                    </v-flex>
                  </v-layout>

                  <v-divider dotted>
                    <v-file-input chips multiple label="File input w/ chips"></v-file-input>
                  </v-divider>
                  <v-layout wrap pt-4>
                    <v-flex xs11 md2 lg11>
                      <span style="color:#000000;font-family: poppinsregular;">Add</span>
                    </v-flex>
                    <v-flex xs2 md10 lg1>
                      <span>
                        <v-btn
                          small
                          :ripple="false"
                          id="pro_pic"
                          class="text-capitalize"
                          outlined
                          color="transparent "
                          width="20"
                          @click="$refs.uploadProPicImg.click()"
                        >
                          <v-img
                            src="./../../assets/images/addicon.png"
                            aspect-ratio="1"
                            contain
                            height="20px"
                          >
                            <template v-slot:placeholder>
                              <v-row class="fill-height ma-0" align="center" justify="center">
                                <v-progress-circular indeterminate color="#26af82"></v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>
                        </v-btn>
                        <input
                          v-show="false"
                          ref="uploadProPicImg"
                          accept="image/*"
                          type="file"
                          @change="uploadProPicImg"
                        />
                      </span>
                    </v-flex>
                  </v-layout>

                  <!-- </v-flex>
              </v-layout>
               <v-layout wrap>
                <v-flex text-left xs12 md12 lg12>
                  <v-file-input prepend-icon="mdi-plus" hide-input multiple></v-file-input>-->
                </v-flex>
              </v-layout>
            </v-card>
            <br />
            <span style="font-family:opensansbold">Bank Details</span>
            <v-card class="mx-auto" outlined>
              <v-layout wrap pa-3>
                <v-flex xs12 md12 lg12>
                  <v-text-field
                    ref="bank"
                    color="#63028F"
                    label="Bank"
                    dense
                    v-model="seller.bankname"
                  ></v-text-field>
                  <v-text-field
                    ref="accountholder"
                    color="#63028F"
                    label="Account Holder"
                    dense
                    v-model="seller.accountholder"
                  ></v-text-field>
                  <v-text-field
                    ref="accountnumber"
                    color="#63028F"
                    label="Account Number"
                    dense
                    v-model="seller.accountnumber"
                  ></v-text-field>
                  <v-layout wrap>
                    <v-flex xs5 md5 lg5>
                      <v-text-field
                        ref="ifsc"
                        color="#63028F"
                        label="IFSC COde"
                        dense
                        v-model="seller.ifsccode"
                      ></v-text-field>
                    </v-flex>

                    <v-flex offset-md1 xs5 md5 lg5>
                      <v-text-field
                        ref="branch"
                        color="#63028F"
                        label="Branch"
                        dense
                        required
                        v-model="seller.branch"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>
            <br />
            <v-text-field
              ref="gstid"
              color="#63028F"
              label="GST Id"
              outlined
              dense
              v-model="seller.gstid"
            ></v-text-field>
            <v-text-field
              ref="email"
              color="#63028F"
              label="Email ID"
              outlined
              dense
              v-model="userData.email"
            ></v-text-field>
            <v-text-field
              ref="phone"
              color="#63028F"
              placeholder="Whatsapp number"
              outlined
              dense
              type="number"
              v-model="userData.phone"
            >
              <template v-slot:prepend-inner>
                <v-layout wrap justify-center>
                  <v-flex pt-1 xs18 class="align-self-center">
                    <span style="font-family:poppinsregular;font-size:14px;color:#000">+91</span>
                  </v-flex>
                  <v-flex pl-2 xs1>
                    <v-divider vertical></v-divider>
                  </v-flex>
                </v-layout>
                <v-card class="mx-auto" outlined></v-card>
              </template>
            </v-text-field>
            <!-- <v-text-field
              color="#63028F"
              label="Whatsapp Number"
              outlined
              dense
              v-model="seller.whatsapp"
            ></v-text-field>-->
            <v-layout wrap justify-end>
              <v-flex xs12 md12 pt-4 pb-4 text-right>
                <v-btn
                  block
                  dark
                  color="#63028F"
                  depressed
                  class="text-capitalize"
                  @click="register"
                  :ripple="false"
                >Submit</v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import store from "../../store";
import axios from "axios";
export default {
  data() {
    return {
      seller: {
        fullname: null,
        email: null,
        phone: null,
        streetAddress: null,
        organization: null,
        whatsapp: null,
        username: null,
        password: null,
        city: null,
        state: null,
        gstid: null,
        accountholder: null,
        accountnumber: null,
        bankname: null,
        ifsccode: null,
        branch: null,
      },
      proPicImg: null,
      proPic: null,
      proPicSts: false,
      documentImg: null,
      document: null,
      documentSts: false,
      showsnackbar: false,
      msg: null,
      ServerError: false,
      validateInput: null,
      timeout: 5000,
      appLoading: false,
      filename: "",
      userData: [],
      uploadPhoto: new FormData(),
      uploadIdProof: new FormData(),
      msg1: null,
    };
  },

  beforeMount() {
    this.getData();
  },
  methods: {
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/user/profile",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.userData = response.data.data;
            this.seller = this.userData;
            this.seller.bankname = this.userData.seller.bankname;
            this.seller.accountholder = this.userData.seller.accountholder;
            this.seller.accountnumber = this.userData.seller.accountnumber;
            this.seller.gstid = this.userData.seller.gstid;
            this.seller.branch = this.userData.seller.branch;
            this.seller.ifsccode = this.userData.seller.ifsccode;
            this.filename = this.userData.seller.idproof[0];
            this.proPicImg = "http://13.235.2.39/u/" + this.userData.image;
            this.loadData = true;
            if (this.userData.dob)
              this.userData.dob = new Date(this.userData.dob)
                .toISOString()
                .substr(0, 10);
          }
        })
        .catch((err) => {
          this.ServerError = true;
          console.log(err);
        });
    },
    uploadProPicImg(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      if (files[0].size > 5097152) {
        // this.msg = "File Should be less than 2MB";
        // this.showsnackbar = true;
        return;
      }
      this.proPic = e.target.files[0];
      var reader = new FileReader();
      reader.onload = (e) => {
        this.proPicImg = e.target.result;
      };
      this.proPicSts = true;
      reader.readAsDataURL(files[0]);
    },
    uploadDocuments(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      if (files[0].size > 5097152) {
        // this.msg = "File Should be less than 2MB";
        // this.showsnackbar = true;
        return;
      }

      this.filename = e.target.files[0].name;
      this.document = e.target.files[0];

      var reader = new FileReader();
      reader.onload = (e) => {
        this.documentImg = e.target.result;
      };
      this.documentSts = true;
      reader.readAsDataURL(files[0]);
    },
    delProPic() {
      this.proPicImg = "";
      this.proPic = "";
    },
    delDocument() {
      // if(this.userData.seller.filename[0])
      // {

      // }
      this.documentImg = "";
      this.document = "";
      this.filename = "";
    },
    uploadDoc() {
      this.uploadIdProof.append("images", this.document);
      this.appLoading = true;
      axios({
        method: "post",
        url: "/user/uploadproofs",
        data: this.uploadIdProof,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
          "Content-Type": "multipart/form-data",
        },
      })
        .then((response) => {
          this.msg = response.data.msg;
          this.appLoading = false;
          // this.showsnackbar = true;
        })

        .catch((e) => {
          console.log(e);
          this.appLoading = false;
        });
    },

    uploadPic() {
      this.uploadPhoto.append("photos", this.proPic);
      this.appLoading = true;
      axios({
        method: "post",
        url: "/user/uploadImage",
        data: this.uploadPhoto,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
          "Content-Type": "multipart/form-data",
        },
      })
        .then((response) => {
          this.msg = response.data.msg;
          this.appLoading = false;
          // this.showsnackbar = true;
        })

        .catch((e) => {
          console.log(e);
          this.appLoading = false;
        });
    },

    register(evt) {
      this.appLoading = true;
      this.seller.fullname = this.userData.fullname;
      this.seller.email = this.userData.email;
      this.seller.whatsapp = this.userData.phone;
      this.seller.id = store.state.userId;
      evt.preventDefault();
      axios({
        method: "POST",
        url: "/user/Edit",
        data: this.seller,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.uploadPic();
            this.uploadDoc();
            if (response.data.data.status == "Active") {
              this.$router.push("/myProducts");
            } else if (response.data.data.status == "Pending") {
              this.showsnackbar = true;
              this.msg1 =
                "Your Account is under processing for Admin Approval... Please wait for a while and Relogin ";
            }
          } else {
            this.msg = response.data.msg;
          }
        })
        .catch((err) => {
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>

<style >
.upload {
  background: transparent url("/assets/images/fileupload.png") 0% 0% no-repeat
    padding-box;
}
</style>